<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="45.627" height="22.82" viewBox="0 0 45.627 22.82">
    <g transform="translate(0 0)">
      <ellipse cx="5.618" cy="5.618" rx="5.618" ry="5.618" transform="translate(17.195 5.791)" fill="#454545" />
      <path
        d="M45.345,52.709c-.411-.435-10.2-10.7-22.534-10.7S.692,52.274.281,52.709a1.04,1.04,0,0,0,0,1.421c.412.435,10.2,10.7,22.53,10.7s22.125-10.267,22.534-10.7A1.034,1.034,0,0,0,45.345,52.709Zm-22.531,9.4A8.687,8.687,0,1,1,31.5,53.419,8.694,8.694,0,0,1,22.814,62.107ZM15.929,45.22a10.618,10.618,0,0,0,0,16.4,37.715,37.715,0,0,1-13.414-8.2A37.746,37.746,0,0,1,15.929,45.22ZM29.7,61.618a10.61,10.61,0,0,0,0-16.4,37.716,37.716,0,0,1,13.411,8.2A37.791,37.791,0,0,1,29.7,61.618Z"
        transform="translate(-0.001 -42.012)"
        fill="#454545"
      />
    </g>
  </svg>
</template>
